export default __webpack_public_path__ + "static/media/ic-settings.9a4cfc85.svg";